import { ICSSInJSStyle } from '@fluentui/react-northstar';
import { ZIndex } from '../utils/styles-helper';

export interface IBannerErrorStyles {
  bannerErrorAlertStyles: ICSSInJSStyle;
  centerWithActions: ICSSInJSStyle;
}

export const bannerErrorStyles: IBannerErrorStyles = {
  bannerErrorAlertStyles: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    zIndex: ZIndex.Sticky,
    height: '40px' // this is in px to match with how uifabric styles the commandbar's height.
  },
  centerWithActions: {
    paddingLeft: '7.1rem'
  }
};
